import { render, staticRenderFns } from "./DemoOverlay.vue?vue&type=template&id=6a765040&scoped=true"
import script from "./DemoOverlay.vue?vue&type=script&lang=js"
export * from "./DemoOverlay.vue?vue&type=script&lang=js"
import style0 from "./DemoOverlay.vue?vue&type=style&index=0&id=6a765040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a765040",
  null
  
)

export default component.exports